var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CheckCircle } from 'shared/assets/icons';
import { Box, CloseIcon, Flex, Icon, Progress, Text } from 'shared/components/ui';
export var ToastSuccessBox = function (_a) {
    var title = _a.title, _b = _a.message, message = _b === void 0 ? '' : _b, _c = _a.onClose, onClose = _c === void 0 ? function () {
        return;
    } : _c, _d = _a.action, action = _d === void 0 ? null : _d, _e = _a.variant, variant = _e === void 0 ? 'success' : _e, progressDuration = _a.progressDuration, _f = _a.toastBoxProps, toastBoxProps = _f === void 0 ? {} : _f;
    var _g = useState(0), PBValue = _g[0], setPBValue = _g[1];
    useEffect(function () {
        var value = 100;
        var intervalId = setInterval(function () {
            if (value < 0) {
                clearInterval(intervalId);
            }
            else {
                setPBValue(value);
                value -= 1;
            }
        }, progressDuration / 100);
        return function () {
            clearInterval(intervalId);
        };
    }, []);
    return (_jsxs(Box, __assign({ justifyContent: "center", display: "flex", flexDirection: "row", alignItems: "center", rounded: "md", color: "".concat(variant, ".text"), bgColor: "".concat(variant, ".light"), pb: "20px", isolation: "isolate", position: "absolute", top: "4", w: "357px", h: "72px", boxShadow: "0px 4px 16px 0px rgba(24, 32, 35, 0.24)" }, toastBoxProps, { children: [_jsxs(Box, __assign({ display: "flex" }, { children: [_jsx(Icon, { fontWeight: "bold", ml: "3.5", mt: "3.5", mr: "8px", fontSize: "xl", as: CheckCircle }), _jsxs(Flex, __assign({ mr: "16px", direction: "column", alignItems: "flex-start" }, { children: [_jsx(Text, __assign({ "data-testid": "toastSuccessBox", fontWeight: "bold", mt: "18px" }, { children: title })), _jsx(Text, { children: message }), action] }))] })), _jsx(Icon, { mr: "3.5", mt: "3.5", onClick: onClose, fontSize: "md", as: CloseIcon }), _jsx(Progress, { colorScheme: variant, w: "100%", zIndex: 1, pos: "absolute", bottom: 0, left: 0, h: "8px", rounded: "md", transitionDuration: "100", value: PBValue })] })));
};
